<template>
  <v-row justify="center">
    <v-dialog v-model="showDialog" persistent max-width="700px">
      <template v-slot:activator="{ onShow }">
        <v-btn color="primary" class="btn-next" v-on="onShow" @click="prepareDialog" >Recibir código</v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline" >{{ !modoCodigo ? titleMovil : titleCodigo}}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="phoneForm"> 
            <v-row v-if="!modoCodigo">
              <v-col cols="12">
                Le enviaremos por SMS un código para que pueda firmar este documento.
              </v-col>
              <v-col cols="12" md="6" >
                <v-text-field label="Teléfono móvil" required v-model="telefonoFirma" 
                 :rules="[validationRules.required,validationRules.phone]" counter="9"
                v-bind:disabled="isLoading" ></v-text-field>
              </v-col>
              
              <v-col cols="12" md="6" class="mt-4">
                <v-btn class="btn-popup"  
                 v-bind:loading="isLoading" @click="requestSignCode"
                  color="primary">
                  Recibir SMS
            </v-btn>
              </v-col>
            </v-row>
            </v-form>

            <v-form ref="codeForm">
             <v-row v-if="modoCodigo">
              <v-col cols="12">
                Introduzca el código que le hemos enviado al número {{telefonoFirma}} y firme el documento.
              </v-col>
              <v-col cols="12" md="6" >
                <v-text-field label="Código de firma" required v-model="codigo" 
                ref="codeTextField" v-bind:error-messages="codeErrorMessage"
                :rules="[validationRules.codigoFirma]" 
                v-bind:disabled="isLoading" counter="5" ></v-text-field>
              </v-col>
              
              <v-col cols="12" md="6" class="mt-4">
                <v-btn  class="btn-popup"   v-bind:loading="isLoading" @click="signNotification"
                  color="primary">
                  Firmar documento
            </v-btn>
              </v-col>
            </v-row>
            </v-form>
          </v-container> 
        </v-card-text>
        <v-card-actions> 
          <v-btn color="primary" float="left" v-if="modoCodigo" text @click="modoCodigo = false" v-bind:disabled="isLoading" >Solicitar otro código</v-btn> 
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="showDialog = false" v-bind:disabled="isLoading" >Cancelar</v-btn> 
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>


<script>
import api from '@Base/services/notificacionService'
import StepBase from '@Base/pages/common/StepBase.js'

  export default {
    name: 'FirmarDialog', 
    mixins: [StepBase],  
     props: ['telefono','idFirmaDocumento'],
     data () {
      return { 
      isLoading: false,
      titleMovil: "Introduzca su teléfono móvil",
      titleCodigo: "Introduzca su código",
       showDialog: false, 
       codigo: null,
        modoCodigo: false,
        telefonoFirma: null,
        codeErrorMessage: null
      }
    }, 
    computed: { 
      tokenGestion () {
        return this.$store.state.solicitud.tokenGestion;
      }
      , 
    },
    methods: {  
       prepareDialog: function()
        {
          this.telefonoFirma=null;
          this.codigo=null;
          this.modoCodigo = false;
          this.showDialog=true;
        },
         requestSignCode: function() {

           if (!this.$refs.phoneForm.validate()) {
              return;
            }
            
            this.isLoading=true;
            this.codigo= null;

            var signCode = {
              idFirmaDocumento: this.idFirmaDocumento,
              numeroTelefono: this.telefonoFirma
            }
            api.requestSignCode (this.tokenGestion,signCode,
            res=> {
                console.log(res);
                this.isLoading=false;
                this.modoCodigo=true;
            },
            error=> {
                console.log(error);
                this.isLoading=false;
                this.$emit('alert-event', { text: 'Error al solicitar código de firma', color: 'red' });
								console.log(error);
            })
         },
         signNotification: function() {

           if (!this.$refs.codeForm.validate()) {
              return;
            }

            this.isLoading=true;

            var signCode = {
              idFirmaDocumento: this.idFirmaDocumento,
              numeroTelefono: this.telefonoFirma,
              codigo: this.codigo
            }

            api.signNotification (this.tokenGestion,signCode,
            res=> {
                console.log(res);
                this.isLoading=false;
                this.modoCodigo=false;
                this.showDialog = false;
                this.$emit('firmada');
            },
            error=> {
                console.log(error);
                this.isLoading=false;
                this.codeErrorMessage="El código introducido es incorrecto";
            })
         }
    },
  }
</script>